import * as React from "react";
import styles from "./styles.module.scss";
import { UseFormRegister } from "react-hook-form";
import { OptionType } from "../select";
import { StarRating } from "components";

interface InputProps {
  dataTestID?: string;
  className?: string;
  parentClassName?: string;
  labelClassName?: string;
  name: string;
  type: "radio" | "checkbox";
  id?: string;
  validatorMessage: string | undefined;
  label?: string;
  instruction?: string;
  register: UseFormRegister<any>;
  value?: string;
  checkValue?: string[];
  showRequired?: boolean;
  disabled?: boolean;
  options: OptionType[];
  rating?: {
    value: number;
    onChange: (x: number) => void;
    count: number;
    startAt: number;
  };
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const RadioInput: React.FC<InputProps> = ({
  dataTestID,
  className,
  parentClassName,
  labelClassName,
  name,
  id,
  validatorMessage,
  label,
  register,
  value,
  showRequired,
  options,
  type,
  disabled,
  checkValue,
  rating,
  instruction,
  onChange,
}) => {
  const registerProps = register(name);
  const normalizeValue = (input: any) => input === undefined || input === null ? '' : String(input);
  
  return (
    <div
      className={`${styles.inputWrapper} ${parentClassName} ${
        validatorMessage ? styles.error : ""
      }`}
    >
      {label && (
        <p className={styles.question}>
          {label}
          {showRequired ? <span className={styles.req}>*</span> : ""}
          {instruction ? (
            <p className={styles.instruction}>{instruction}</p>
          ) : (
            ""
          )}
        </p>
      )}

      {options.map((option, index) => {
        const isChecked = type === 'radio' 
          ? normalizeValue(value) === normalizeValue(option.value) 
          : (checkValue || []).map(normalizeValue).includes(normalizeValue(option.value));
        
        return (
          <label key={index} className={`${styles.label} ${labelClassName ?? ""}`} htmlFor={`${name}-${option.value}-${index}`}>
            <div className={`${styles.optionWrap} ${className ?? ""}`}>
              <input
                data-testid={dataTestID}
                className={`${styles.input} ${type === 'radio' ? styles.radio : styles.checkbox}`}
                type={type}
                id={`${name}-${option.value}-${index}`}
                {...registerProps}
                value={option.value}
                checked={value !== undefined || checkValue !== undefined ? isChecked : undefined}
                onChange={(e) => {
                  registerProps.onChange(e);
                  onChange?.(e);
                }}
                disabled={
                  disabled && !(checkValue || []).map(normalizeValue).includes(normalizeValue(option.value))
                }
              />
              {option.description ? (
                <span>
                  <span className={styles.optionTitle}>{option.label}</span>
                  <span className={styles.optionDescription}>{option.description}</span>
                </span>
              ) : (
                <span>{option.label}</span>
              )}
            </div>
            {rating && normalizeValue(value) === normalizeValue(option.value) && (
              <StarRating {...rating} className={styles.ratingSec} />
            )}
          </label>
        );
      })}

      {validatorMessage && (
        <small className={styles.message}>{validatorMessage}</small>
      )}
    </div>
  );
};

export { RadioInput };